import { dia } from '@clientio/rappid';

/**
 * Resets a JointJS links arrowhead.
 *
 * @param linkView - The JointJS link view to get its arrowhead reset.
 */
export const resetArrowHead = (linkView: dia.LinkView) => {
  linkView.model.attr('line/targetMarker', {
    class: 'link__arrowhead',
  });
};

/**
 * Selects a JointJS link by setting its selected status and updating its target marker.
 *
 * @param linkView - The JointJS link view to be selected.
 */
export const markLinkAsSelected = (linkView: dia.LinkView) => {
  linkView.model.set('selected', true);
  linkView.model.attr('line/targetMarker', {
    class: 'link__arrowhead selected',
  });
};

export const unselectAllLinks = (graph: dia.Graph, paper: dia.Paper) => {
  const links = graph.getLinks();
  links.forEach((link: joint.dia.Link) => {
    const linkView = paper.findViewByModel(link);

    if (!(linkView instanceof dia.LinkView)) return;

    resetArrowHead(linkView);
  });
};
